import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=3cc39c11&scoped=true&"
import script from "./RatingInput.vue?vue&type=script&lang=js&"
export * from "./RatingInput.vue?vue&type=script&lang=js&"
import style0 from "./RatingInput.vue?vue&type=style&index=0&id=3cc39c11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc39c11",
  null
  
)

export default component.exports